import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";

import { Button } from "../../../../../../stories/Button/Button";
import { Label } from "../../../../../../stories/Label/Label";
import Input from "../../../../../../stories/Input/Input";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import {
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { AntSwitch } from "../../../../../../styles/Switch";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { LabelProps } from "../../../../../../utils/types";
import {
  SupplierFormDetails,
  SupplierRequiredDetails,
} from "../../../../../../utils/formTypes";
import {
  GetSupplierByNodeId,
  GetSupplierMultiLocation,
} from "../queries/queries";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";
import {
  AtsAcLdgr,
  AtsAcLdgrMultiLocationOrderField,
  GetSupplierMultiLocationResult,
  GetSupplierMultiLocationVars,
} from "../queries/types";
import { useLazyQuery } from "@apollo/client";

import { AppContext } from "../../../../../../context/context";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { EMPTY_STRING } from "../../../../../../utils/constants";
import useLabels from "../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../json/useFormJson";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const View = ({ setModalFlag }: Props) => {
  const [requiredDetails, setRequiredDetails] = useState(false);
  const { Masters_Table } = useAssetTableJson();
  const{Masters}=useFormJson();

  const { customer_id } = useUrlParams();
  const { state } = useContext(AppContext);
  const initialValues: SupplierFormDetails = {
    supplier_name: "",
    address: "",
    city: "",
    state: "",
    pin: "",
    country: "",
    phone: "",
    email: "",

    multi_location: false,

    contactPerson: "",
    contactPersonAddress: "",
    contactPersonState: "",
    contactPersonCity: "",
    contactPersonPin: "",
    contactPersonCountry: "",
    contactPersonMobile: "",
    contactPersonEmail: "",
    contactPersonAadhar: "",
  };

  const reqInitialValues: SupplierRequiredDetails = {
    gstNo: "",
    tanNo: "",
    panNo: "",
    vatNo: "",
    bankAcNo: "",
    bankName: "",
    bankBranch: "",
    bankIfsc: "",
    bankMicr: "",
    proficiency: "",
    alterContactPerson: "",
    alterContactPersonMobile: "",
    alterContactPersonEmail: "",
    alterContactPersonAadhar: "",
  };

  const [reqFormData, setreqFormData] =
    useState<SupplierRequiredDetails>(reqInitialValues);

  const [formData, setFormData] = useState<SupplierFormDetails>(initialValues);

  const [GetSupplier, { data: supplierData }] = useLazyQuery<
    { node: AtsAcLdgr },
    nodeVar
  >(GetSupplierByNodeId);

  const [GetLocations, { data: locationsData }] = useLazyQuery<
    GetSupplierMultiLocationResult,
    GetSupplierMultiLocationVars
  >(GetSupplierMultiLocation);

  useEffect(() => {
    if (state.supplierId) {
      GetSupplier({
        variables: {
          id: state.supplierId,
          
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setreqFormData({
            gstNo: data.node.supplier_details.gstNo,
            tanNo: data.node.supplier_details.tanNo,
            panNo: data.node.supplier_details.panNo,
            vatNo: data.node.supplier_details.vatNo,
            bankAcNo: data.node.supplier_details.bankAcNo,
            bankName: data.node.supplier_details.bankName,
            bankBranch: data.node.supplier_details.bankBranch,
            bankIfsc: data.node.supplier_details.bankIfsc,
            bankMicr: data.node.supplier_details.bankMicr,
            proficiency: data.node.supplier_details.proficiency,
            alterContactPerson:
              data.node.supplier_details.alterContactPerson,
            alterContactPersonMobile:
              data.node.supplier_details.alterContactPersonMobile,
            alterContactPersonEmail:
              data.node.supplier_details.alterContactPersonEmail,
            alterContactPersonAadhar:
              data.node.supplier_details.alterContactPersonAadhar,
          });
          setFormData({
            supplier_name: data.node.desc,
            address: data.node.supplier_details.address,
            city: data.node.supplier_details.city,
            state: data.node.supplier_details.state,
            pin: data.node.supplier_details.pin,
            country: data.node.supplier_details.country,
            phone: data.node.supplier_details.phone,
            email: data.node.supplier_details.email,

            multi_location: false,

            contactPerson: data.node.supplier_details.contactPerson,
            contactPersonAddress:
              data.node.supplier_details.contactPersonAddress,
            contactPersonState:
              data.node.supplier_details.contactPersonState,
            contactPersonCity: data.node.supplier_details.contactPersonCity,
            contactPersonPin: data.node.supplier_details.contactPersonPin,
            contactPersonCountry:
              data.node.supplier_details.contactPersonCountry,
            contactPersonMobile:
              data.node.supplier_details.contactPersonMobile,
            contactPersonEmail:
              data.node.supplier_details.contactPersonEmail,
            contactPersonAadhar:
              data.node.supplier_details.contactPersonAadhar,
          });
        }
      });
    }
  }, [GetSupplier, state.supplierId, supplierData]);
  useEffect(() => {
    if (customer_id) {
      GetLocations({
        variables: {
          after: null,
          customer_id,
          first: null,
          name: EMPTY_STRING,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsAcLdgrMultiLocationOrderField.CITY,
          },
          supplier_id: state.supplierId,
          
        },
      });
    }
  }, [GetLocations, state.supplierId, customer_id]);
  const {ledgerLabel}=useLabels();
  return (
    <>
      <div className="supplier__view">
        <div className="supplier__view--title">
          <Title>View {ledgerLabel}</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="supplier__view--tabs">
          <button
            onClick={() => setRequiredDetails(false)}
            className={!requiredDetails ? "active" : ""}
          >
            Basic Details
          </button>
          <button
            onClick={() => setRequiredDetails(true)}
            className={requiredDetails ? "active" : ""}
          >
            Required Details
          </button>
        </div>
        {!requiredDetails ? (
          <div className="supplier__view--block">
            <div className="supplier__view--block--left">
              <div className="supplier__add--details">
                <h4>{ledgerLabel} Details</h4>
              </div>
              <div className="label-grid">
                <Label>{ledgerLabel} Name</Label>
                <Input disabled value={formData.supplier_name} />
                <Label>Address</Label>
                <TextArea rows={3} disabled value={formData.address} />
                {Masters.Supplier.BasicDetails.Supplier.map(
                  (res: LabelProps, index: React.Key) => {
                    return (
                      <React.Fragment key={index}>
                        <Label>{res.labelName}</Label>
                        <Input disabled value={formData[res.inputName]} />
                      </React.Fragment>
                    );
                  }
                )}
              </div>
            </div>
            <div className="supplier__view--block--right">
              <div className="supplier__add--details">
                <h4>Contact Person Details</h4>
              </div>
              <div className="label-grid">
                <Label> Name</Label>
                <Input disabled value={formData.contactPerson} />
                <Label>Address</Label>
                <TextArea
                  rows={3}
                  disabled
                  value={formData.contactPersonAddress}
                />
                {Masters.Supplier.BasicDetails.ContactPersonDetails.map(
                  (res: LabelProps, index: React.Key) => {
                    return (
                      <React.Fragment key={index}>
                        <Label>{res.labelName}</Label>
                        <Input disabled value={formData[res.inputName]} />
                      </React.Fragment>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="supplier__view--block">
            <div className="supplier__view--block--left">
              <div className="supplier__add--details">
                <h4>Required Details</h4>
              </div>
              <div className="label-grid">
                {Masters.Supplier.RequiredDetails.Details.map(
                  (res: LabelProps, index: React.Key) => {
                    return (
                      <React.Fragment key={index}>
                        <Label>{res.labelName}</Label>
                        <Input disabled value={reqFormData[res.inputName]} />
                      </React.Fragment>
                    );
                  }
                )}
              </div>
            </div>
            <div className="supplier__view--block--right">
              <div className="supplier__add--details">
                <h4>Alternate Contact Person Details</h4>
              </div>
              <div className="label-grid">
                {Masters.Supplier.RequiredDetails.AlternateContactPersonDetails.map(
                  (res: LabelProps, index: React.Key) => {
                    return (
                      <React.Fragment key={index}>
                        <Label>{res.labelName}</Label>
                        <Input disabled value={reqFormData[res.inputName]} />
                      </React.Fragment>
                    );
                  }
                )}
              </div>
              {supplierData && supplierData.node.multiLocation ? (
                <>
                  <div className="supplier__add--details">
                    <h4>Multiple Location Available</h4>
                  </div>
                  <div className="supplier__add--details--block">
                    <FormControlLabel
                      label="Multiple Location Available"
                      labelPlacement="start"
                      control={<AntSwitch disabled />}
                      className="supplier__add--details--form-labels"
                    />

                    <div className="supplier__add--details--tableblock">
                      <Title variant="subtitle1">
                        <b>Default and Primary Details</b>
                      </Title>

                      <TableContainer className="supplier__add--details--table">
                        <Table stickyHeader>
                          <TableHead>
                            <TableRow>
                              {Masters_Table.Masters.MultipleLocation.map(
                                (res, index) => {
                                  return (
                                    <TableCell key={index}>
                                      {res.headerName}
                                    </TableCell>
                                  );
                                }
                              )}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {locationsData
                              ? locationsData.GetSupplierMultiLocation.edges.map(
                                  (mul_loc, index) => {
                                    return (
                                      <TableRow key={index + 1}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>
                                          {mul_loc.node.state}
                                        </TableCell>
                                        <TableCell>
                                          {mul_loc.node.address}
                                        </TableCell>
                                        <TableCell>
                                          {mul_loc.node.gstNo}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  }
                                )
                              : null}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        )}

        <Button mode="cancel" onClick={() => setModalFlag(false)} />
      </div>
    </>
  );
};

export default View;
